import React from 'react';
import { AlertCircle, RefreshCw, ArrowLeft } from 'lucide-react';

class AdminErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Admin page error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-cream flex items-center justify-center p-6">
          <div className="bg-white rounded-2xl shadow-sm border border-navy/5 p-8 max-w-md w-full text-center">
            <div className="w-16 h-16 mx-auto mb-4 rounded-xl bg-red-50 flex items-center justify-center">
              <AlertCircle size={32} className="text-red-500" />
            </div>
            <h2
              className="text-xl mb-2"
              style={{ fontFamily: "'Playfair Display', serif", fontWeight: 500, color: '#1e1b4b' }}
            >
              Something went wrong
            </h2>
            <p className="text-sm text-gray-500 mb-6">
              An error occurred while rendering this page. Try refreshing or go back.
            </p>
            <div className="flex gap-3 justify-center">
              <button
                onClick={() => window.history.back()}
                className="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-xl text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
              >
                <ArrowLeft size={16} />
                Go Back
              </button>
              <button
                onClick={() => window.location.reload()}
                className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-[#6F5BEB] to-[#8B5CF6] text-white rounded-xl text-sm font-medium hover:opacity-90 transition-all"
              >
                <RefreshCw size={16} />
                Reload Page
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default AdminErrorBoundary;
